// The past-sessions archive's copy, in one place so the page and its suite
// reference the same string.
//
// NOT here: a row's date and time. Those are `Intl` formatting of session data,
// not copy — the suite asserts the formatted result directly, because that IS
// the behaviour under test.

/** Matches the flow-wide fallback: lowercase, so it can never open a sentence. */
export const FALLBACK_THERAPIST_NAME = "your therapist";

export const PAST_SESSIONS_COPY = {
  title: "Past sessions",
  sub: (therapistName: string) => `Every session you’ve had with ${therapistName}.`,
  /** Accessible name of the icon-only back circle. */
  backLabel: "Back to home",
  loadingLabel: "Loading sessions…",
  emptyTitle: "No past sessions yet",
  emptyBody: "Your completed sessions will appear here after they end.",
  loadMoreLabel: "View more",
  loadingMoreLabel: "Loading…",
  feedbackLabel: "Share feedback",
  /** Names the session, so rows are distinguishable to a screen reader. */
  feedbackAriaLabel: (sessionNumber: number) => `Share feedback for session ${sessionNumber}`,
} as const;
